<template>
  <utd-alert-dialog ref="modalDialog"
                    :hide-header-close="false"
                    :title="title"
                    :class-names="modalClasses"
                    dialog-size="medium"
                    @closed="$emit('modal-closed')">
    <div class="notice-dialog__content">
      <div class="notice-dialog__heading">
        <span class="notice-dialog__heading-label wkce-icon" :class="iconClass" />
        <h5 class="notice-dialog__heading-label">
          {{ heading }}
        </h5>
      </div>
      <div class="notice-dialog__content-body"><slot /></div>
      <ul class="notice-dialog__content-bullets">
        <li v-for="(line, i) in bodyBullets" :key="i">{{ line }}</li>
      </ul>
    </div>
  </utd-alert-dialog>
</template>

<script lang="ts" setup>
import UtdAlertDialog from '_acaSrc/components/shared/stdlib/UtdAlertDialog.vue';
import { computed, ref } from 'vue';

const { title, heading, bodyBullets, iconClass, classNames } = defineProps<{
  title: string,
  heading: string,
  bodyBullets?: string[],
  iconClass: string,
  classNames?: string
}>();

defineEmits([ 'modal-closed' ]);

const modalDialog = ref(null);
const openModal = () => {
    modalDialog.value.open();
};
const closeModal = () => {
    modalDialog.value.close();
};

const modalClasses = computed(() => {
    const propClasses = classNames ?? '';
    return `utd-notice-dialog ${propClasses}`;
});

defineExpose({
    openModal,
    closeModal
});
</script>

<style lang="less" scoped>
  @import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

  .notice-dialog__content {
    .ds1-mb-3();
  }

  .notice-dialog__heading {
    .ds1-mb-1();
    display: flex;

    .notice-dialog__heading-label {
      .ds1-utd-size-5();
      .ds1-ml-2();
      .ds1-utd-weight-bold();

      &.wkce-icon {
        .ds1-utd-weight-normal();
        .ds1-ma-0();
        font-size: 24px;
        color: @DS1-UTD-INFO;
      }
    }
  }

  .notice-dialog__content-body,
  .notice-dialog__content-bullets {
    .ds1-pb-1();
    .ds1-ml-5();
    margin-block: 0;

    li, p {
      .ds1-pb-1();
    }
  }

  .notice-dialog__content-body ul,
  .notice-dialog__content-bullets {
    .ds1-ml-3();
  }

  :global(.utd-notice-dialog #utd-modal-dialog-header) {
    .ds1-utd-weight-600();
  }
</style>